import api from '../../../services/api';

/**
 * Fetch a single RFP by ID
 */
export const fetchRFPById = async (rfpId) => {
    return api.get(`/rfp/${rfpId}`);
};

/**
 * Fetch overview of an RFP for Team Lead
 */
export const fetchRFPOverview = async (rfpId) => {
    return api.get(`/rfp/lead/${rfpId}/overview`);
};

/**
 * Fetch all proposals
 */
export const fetchAllProposals = async (params = '') => {
    const query = params.startsWith('?') ? params : (params ? `?${params}` : '');
    return api.get(`/rfp/all${query}`);
};

/**
 * Update RFP Status
 */
export const updateRFPStatus = async (rfpId, status) => {
    return api.patch(`/rfp/${rfpId}/status`, { status });
};

/**
 * Update Proposal Stage
 */
export const updateProposalStage = async (rfpId, stage, statusCode, notes = '', additionalBodyFields = {}) => {
    return api.patch(`/rfp/${rfpId}/proposal-stage`, { 
        stage, 
        status_code: statusCode, 
        notes, 
        ...additionalBodyFields 
    });
};

/**
 * Update RFP Metadata (v1)
 */
export const updateRFPMetadata = async (rfpId, metadata) => {
    return api.patch(`/rfp/v1/${rfpId}/metadata`, metadata);
};

/**
 * Analyze RFP with files
 */
export const analyzeRFP = async (formData) => {
    return api.post('/rfp/analyze', formData);
};

/**
 * Update RFP Analysis details
 */
export const updateRFPAnalysis = async (rfpId, payload) => {
    return api.put(`/rfp/analysis/${rfpId}`, payload);
};

/**
 * Delete an RFP
 */
export const deleteRFP = async (rfpId) => {
    return api.delete(`/rfp/${rfpId}`);
};

/**
 * Improve a section with AI (Core / Shared)
 */
export const improveWithAI = async (rfpId, sectionId, prompt) => {
    return api.post(`/rfp/${rfpId}/refine`, { section_id: sectionId, prompt });
};

/**
 * Fetch Go/No-Go assessment data
 */
export const fetchGoNoGoData = async (rfpId) => {
    return api.get(`/extraction/v1/${rfpId}/go-no-go`);
};

/**
 * Upload an image for the RFP editor
 */
export const uploadImage = async (rfpId, formData) => {
    return api.post(`/rfp/${rfpId}/upload-image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

/**
 * Delete an image from the RFP editor
 */
export const deleteImage = async (rfpId, filename) => {
    return api.delete(`/rfp/${rfpId}/image/${filename}`);
};

/**
 * Refine section content with AI
 */
export const refineSectionContent = async (payload) => {
    return api.post('/rfp/refine-section', payload);
};

/**
 * Fetch assigned users for a specific RFP (Team Lead)
 */
export const fetchAssignedUsers = async (rfpId) => {
    return api.get(`/rfp/lead/${rfpId}/assigned-users`);
};

/**
 * Fetch user's team members
 */
export const fetchMyTeam = async () => {
    return api.get('/rfp/auth/my-team');
};

/**
 * Fetch employee's assigned sections
 */
export const fetchMySections = async (rfpId) => {
    return api.get(`/rfp/employee/${rfpId}/my-sections`);
};
